var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPercent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1012 13.9973L13.0963 6.0022",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60242 8.00733C6.00122 8.00733 6.38368 7.84891 6.66568 7.56692C6.94767 7.28493 7.10609 6.90247 7.10609 6.50367C7.10609 6.10487 6.94767 5.72241 6.66568 5.44041C6.38368 5.15842 6.00122 5 5.60242 5C5.20362 5 4.82116 5.15842 4.53917 5.44041C4.25718 5.72241 4.09875 6.10487 4.09875 6.50367C4.09875 6.90247 4.25718 7.28493 4.53917 7.56692C4.82116 7.84891 5.20362 8.00733 5.60242 8.00733ZM13.5975 15C13.9963 15 14.3788 14.8416 14.6608 14.5596C14.9428 14.2776 15.1012 13.8951 15.1012 13.4963C15.1012 13.0975 14.9428 12.7151 14.6608 12.4331C14.3788 12.1511 13.9963 11.9927 13.5975 11.9927C13.1987 11.9927 12.8163 12.1511 12.5343 12.4331C12.2523 12.7151 12.0939 13.0975 12.0939 13.4963C12.0939 13.8951 12.2523 14.2776 12.5343 14.5596C12.8163 14.8416 13.1987 15 13.5975 15Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPercent);
export default ForwardRef;